import { Action } from 'redux';

import { RemoveAlert } from '../../app/actions/AppActionTypes';
import { isActionFactory } from '../../app/actions/isActionFactory';

export interface RemoveAlertAction extends Action {
  alertId: string;
}

export function removeAlertAction(alertId: string): RemoveAlertAction {
  return {
    type: RemoveAlert,
    alertId: alertId
  };
}

export const isRemoveAlertAction = isActionFactory<RemoveAlertAction>(RemoveAlert);
